// Container
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Management
const ManageRoleList = () => import('@/modules/roles/views/management/ManageRoleList')
const ManageRolePermissions = () => import('@/modules/roles/views/management/ManageRolePermissions')

var routes = [
    {
        path: '/roles',
        redirect: '/roles/manage/list',
        name: 'Manage Role',
        component: DefaultContainer,
        children: [
            {
				path: 'manage/list',
                name: 'Manage Role List',
                component: ManageRoleList,
                meta: {
                    requiresAuth: true,
                    permission: false,
                },
            },
            {
				path: 'manage/:role_id',
                name: 'Manage Role Permissions',
                component: ManageRolePermissions,
                meta: {
                    requiresAuth: true,
                    permission: false,
                },
            },
        ]
    },
];

export default routes;
